<template>
    <div> 
        <div class="row">
            <div class="col-lg-7">
                <h4 v-if="admon">Cuenta Administración <br><b>{{ cta.user }} </b></h4>
                <h4 v-else>Cambiar Contraseña</h4>
                
                <b-form @submit.prevent="submit" v-show="!admon">                                          
                    <div class="form-row">                                                                   
                        <b-form-group label="Nueva Contraseña" class="col-sm-12">                            
                            <b-form-input ref="new" v-model="cta.new" required trim :type="type" minlength="6" maxlength="15"></b-form-input>
                        </b-form-group>                    
                    </div>
                    <div class="form-row">                                                                   
                        <b-form-group label="Confirmar Nueva Contraseña" class="col-sm-12">                            
                            <b-form-input ref="con" v-model="cta.con" required trim :type="type" minlength="6" maxlength="15"></b-form-input>
                        </b-form-group>                    
                    </div>
                    <hr>
                    <b-button type="submit" block variant="success">cambiar Contraseña</b-button>            
                </b-form>                

            </div>
<!-- Informacion Derecha -->
            <div class="col-lg-5 mt-3 mt-lg-0">
                <div class="bg-light-2 p-1">
                    <p class="mb-1"><b><i>Importante !!</i></b></p><hr>
                    <p class="small">La contraseña debe tener al menos 6 caracteres alfanuméricos, y un máximo de 15, incluyendo al menos una letra y un número.</p><hr>
                    <p class="small">No podrá utilizar las últimas 3 claves introducidas.</p><hr>                    
                    <p class="small">La contraseña tiene una caducidad de 120 días desde la activación.</p><hr>
                    
                </div>
            </div>
        </div>                                                  

    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'cambio-password',
    components: {
        //publicidad,
    },
    data() {
        return {
            cta: { pas:'', new:'', con:'' },

            submitted: false,
            message: 'Error', 

            visible: false,
        };
    },
    computed: {        
        ...mapState(['auth','errores']),

        /* cta() {
            return this.auth.user;
        }, */
        admon() {
            return false; //(this.cta.dep=='ADMON');
        },      
        type() {
            return (this.visible ? 'text' : 'password');
        },
        icono() {
            return (this.visible ? 'eye-slash-fill' : 'eye-fill');
        }, 
        
    },
    methods: {
        ...mapMutations(['loading','alerta','modal','showModal']),
        ...mapActions(['exec']),

        submit(evt) { 
            evt.preventDefault();            

            //validacion errores
            if (!this.validar()) return;

            this.submitted=true;                                
            this.enviar();
        },
        async enviar() {
            //this.loading();

            var args={user: this.auth.user, pas: this.cta.new};
            let r=await this.exec({api:'info_password', arg: args });

            if (r.error) {
                this.eerrores(r);
                return;
            }
            //let msg=r.error ? this.errores(r) : 'Su contraseña ha sido Activada / Restablecida';
            let msg='Su contraseña ha sido Activada / Restablecida';            
            this.modal({tit:"Cambio Contraseña", msg:msg});

            this.submitted=false;
            //this.loading(false);            

            this.close();
            this.$router.push('/');
        },

        eerrores(r) {
            let m1="<small>Debes de contactar con nosotros en el Teléfono <br><b>900 35 10 10</b>.</small>";
            let m2="<small>Para cualquier duda o consulta puedes contactar con nosotros en el Teléfono <br><b>900 35 10 10</b>.</small>";
            //this.modal({tit:"Login/Acceso", msg: m});

            //if (r.error) {            
                let m=r.datos;
                if (m=='usu')  m="Datos de Usuario incorrectos. Inténtelo de nuevo.<br><br>" + m2; else
                if (m=='tfn')  m="No disponemos de su correo electrónico para iniciar el procedimiento para restablecer su contraseña para acceder a la web.<br><br>" + m1; else
                if (m=='pas')  m="Datos de Acceso erroneos. Inténtelo de nuevo.<br>"; else
                if (m=='pas1') m="Su contraseña no cumple los criterios de seguridad<br> Debe contener entre 6 y 15 caracteres, al menos una letra y ún número.<br>"; else
                if (m=='pas2') m="Su contraseña no cumple los criterios de seguridad<br> Debe contener 6 y 15 caracteres, al menos una letra y ún número.<br>"; else
                if (m=='pas3') m="Su contraseña no cumple los criterios de seguridad<br> No puede ser la misma o estar contenida de las tres últimas utilizadas.<br>"; else
                if (m=='cad')  m="Su contraseña ha caducado o no ha sido inicializada esta temporada.<br>Deberá pulsar Restablecer Contraseña y seguir el procedimiento que se le indica.<br>"; else
                if (m=='ema')  m="Se ha procedido al envio de un email a su direccion de correo con un enlace para restablecer/activar su cuenta de acceso a la web. Siga las indicaciones del mismo.<br><br>" + m2; else
                if (m=='fhp')  m="Procedimiento de Restablecer Contraseña ha caducado, deberá solicitarlo de nuevo.<br><br>" + m2; else
                m="Error - En estos momentos imposible procedimiento.<br><br><b>" + m +"</b><br><br>"+m2;
                
                //m="Su contraseña ha caducado o no ha sido inicializada esta temporada.<br>Deberá pulsar Restablecer Contraseña y seguir el procedimiento que se le indica.<br>";

                this.modal({tit:"Cambio Contraseña", msg: m, time:0});            
                //return;
            //}    
            //
            //return m;
        },  

        validar() {
            //controlar errores passwords
            var msg='';

            // if (this.cta.pas==this.cta.new) {
            //     msg+='La nueva contraseña no puede ser la misma que la actual';                
            //     this.$refs.new.focus();

            // } else {
                let res=this.validPass(this.cta.new,this.cta.con);
                if (!res.valid) {
                    res.errors.forEach((value) => {
                        msg+=value+"<br>";                      
                    });
                    this.$refs.new.focus();
                }
            //}
            if (msg>'') this.modal({tit:"Cambio Contraseña", msg:msg});                                            
            return (msg==='');
        },

        validPass(pass,check) {
            let errors=[];
            if (pass=='' || check=='') errors.push("Debe rellenar el Password/Contraseña");
            if (pass!== check) errors.push("Las contraseñas introducidas no coinciden");

            var rules=[
                { msg:"Mínimo 6 caracteres", regex:/.{6,15}/ },
                // { msg:"Un carácter numérico", regex:/[0-9]+/ },
                // { msg:'Un caracter en minúscula', regex:/[a-z]+/ },
                // { msg:"Un caracter en mayusculas",  regex:/[A-Z]+/ },								
                // { msg:"Un caracter especial (,;.:-_+*!$%&=)",  regex:/[,;.:-_+*!$%&=]+/ },								
            ];

            for (let condition of rules) {
				if (!condition.regex.test(pass)) {
					errors.push(condition.msg)
				}
            }
            return { valid: (errors.length === 0), errors };			
        },     

         close() {
            this.$bvModal.hide('modal_password');
        },
        
    },
}
</script>
